<div class="chat-questions-container">
    @if (isLoading_()) {
      <ods-loader
        class="chat-questions-loading-indicator"
        max="100"
        variant="spinner"
      />
    }
    @else {
      @if (showChatOptions_()) {
        <app-chat-options
          [promptText_]="promptText_()"
          [chatOptions_]="filteredChatOptions_()"
          (teamSelected)="handleTeamSelection($event)"
          (topicSelected)="handleTopicSelected($event)"
        />
      }
      @else {
        <app-chat-validation-questions
          [securitySettings]="securitySettings"
          [teamSelection_]="teamSelection_()"
          (chatTokenAcquired)="handleChatTokenAcquired($event)"
        />
      }
    }
</div>
@if (showDisclaimer_()) {
  <app-chat-disclaimer
    @showHide
    (beginChatSelected)="handleBeginChatSelected()"
    (cancelChatSelected)="handleCancelChatSelected()"
  />
}
